
import Vue from "vue";
import store from "@/store";
import LINK from "@/utils/link";
import { provinces, cities } from "@/utils/geography";
import AppLoading from "@/components/UI/AppLoading.vue";
import AppWarning from "@/components/UI/AppWarning.vue";
import { convertToPersian, separateDigits } from "@/utils/string";

export default Vue.extend({
  name: "AdminsUsersList",
  components: { AppLoading, AppWarning },
  data() {
    return {
      userId: "",

      selectedUser: {
        id: "",
        avatar: "",
        mobile: "",
      },

      LINK: LINK,
      defaultAvatar: require("@/assets/img/default-user.png"),

      dialog: false,
      editDialog: false,
      HeadersTable: [
        "ردیف",
        "نام و نام خانوادگی",
        "موبایل",
        "موجودی",
        "پروفایل",
        "عملیات",
        "خدمات",
      ],
    };
  },
  computed: {
    usersListData(): any[] {
      return store.state.admin.usersList;
    },
    // wallet charge
    amount: {
      get(): number {
        return store.state.admin.amountWalletCharge.amount;
      },
      set(value: number): void {
        store.dispatch("admin/setAmountWalletCharge", value);
      },
    },
    // user profile
    name: {
      get(): string {
        return store.state.admin.userProfile.fullname || "";
      },
      set(value: string): void {
        store.dispatch("admin/setUserFullname", value);
      },
    },
    address: {
      get(): string {
        return store.state.admin.userProfile.address || "";
      },
      set(value: string): void {
        store.dispatch("admin/setUserAddress", value);
      },
    },
    province: {
      get(): string {
        return store.state.admin.userProfile.province || "";
      },
      set(value: string): void {
        store.dispatch("admin/setUserProvince", value);
      },
    },
    city: {
      get(): string {
        return store.state.admin.userProfile.city || "";
      },
      set(value: string): void {
        store.dispatch("admin/setUserCity", value);
      },
    },
  },
  methods: {
    provinces,
    cities,
    showDialog(id: string) {
      this.userId = id;
      this.dialog = true;
    },
    showEditDialog(data: any) {
      this.editDialog = true;

      // set selected user data
      this.selectedUser = {
        id: data._id,
        avatar: data.avatar,
        mobile: data.mobile,
      };

      // set user profile data on state
      const userProfile = {
        fullname: data.fullname,
        address: data.address,
        province: data.province,
        city: data.city,
        avatar: data.avatar,
      };
      this.setUserProfile(userProfile);
    },
    uploadAvatar(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();
        // update avatar in state and place on image placeholder
        fileReader.onload = (event) => {
          store.dispatch("admin/setUserAvatar", event?.target?.result);
        };
        fileReader.readAsDataURL(file);

        // send image
        let formData = new FormData();
        formData.append("image", file);
        store.dispatch("admin/editUserAvatar", {
          formData,
          id: this.selectedUser.id,
        });
      }
    },
    removeAvatar(): void {
      store.dispatch("admin/removeUserAvatar");
    },
    setUserProfile(data: any) {
      store.dispatch("admin/setUserProfile", data);
    },
    chargeUserWallet() {
      store.dispatch("admin/chargingTheUserWallet", this.userId);

      // close modal
      this.dialog = false;
    },
    editUserProfile() {
      store.dispatch("admin/editUserProfile", this.selectedUser.id);

      // close modal
      this.editDialog = false;
    },
    separateDigits,
    convertToPersian,
  },
  created(): void {
    // call get users list action if they're not exist (request)
    if (!store.state.admin.usersList.length) {
      // start page loading
      store.state.app.pageLoading = true;

      // get users list
      setTimeout(function () {
        store.dispatch("admin/getUsersList");
      }, 2000);
    }
  },
});
